import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import Text from "components/Text";
import Page from "components/Page";
import styles from "./OwnerViewContract.module.scss";
import { useOfficeDetail } from "repositories/office-repository";
import { useContractTemplateById } from "repositories/contract-repository";
import * as moment from "moment";
import PreviewPersonnelContract from "./components/PreviewPersonnelContract";
import PreviewAssociateContract from "./components/PreviewAssociateContract";
import Loader from "components/Loader";
import toast from "react-hot-toast";
import { decodeId, parseCalendarDateToLocalDate } from "utils";
import { addDataIntoContractArray } from "../NewEmploymentContract/components/AddContract";
import { useQueryClient } from "react-query";

function OwnerViewContract({ history, match, location, t }) {
  let officeName = null;
  if (location.state && location.state.officeName) {
    officeName = location.state.officeName;
  }
  const officeId = match.params.officeId;
  const contractId = decodeId(match.params.contractId);
  const [designationType, setDesignationType] = useState(2);
  const [contractFormDisplayData, setDisplayData] = useState([]);

  const [BasicDetails, setBasicDetails] = useState({
    contractId,
    IsSubmitted: false,
    Type: 2,
    Date: moment().toDate(),
    BusinessLegalName: officeName,
    Position: "",
    OfficeAddress: "",
    LengthOfEmployment: "",
    StartOfWorkDate: moment().toDate(),
    EndOfWorkDate: moment().add(1, "d").toDate(),
    EmployeeName: "",
    EmployeeAddress: "",
    Salary: "",
    ContractDetails: [],
    commission: "",
    bonus: "",
  });

  useEffect(() => {
    addDataIntoContractArray({
      BasicDetails,
      officeDetail,
      setDisplayData,
    });
    // eslint-disable-next-line
  }, [BasicDetails]);
  const { isLoading: isLoadingOfficeDetail, data: officeDetail } =
    useOfficeDetail(decodeId(officeId));
  let {
    isLoading: isLoadingTemplate,
    data: contractTemplateData,
    error: contractTemplateError,
  } = useContractTemplateById(contractId);
  const queryClient = useQueryClient();
  useEffect(() => {
    return () => {
      queryClient.invalidateQueries(["/Contract/ContractId", contractId]);
    };
  }, []);
  if (!isLoadingTemplate && !contractTemplateData && contractTemplateError) {
    toast.error(contractTemplateError.message, {
      id: "error",
    });
    history.goBack();
  }
  if (
    !isLoadingTemplate &&
    contractTemplateData &&
    BasicDetails.ContractDetails.length === 0
  ) {
    let tempData = { ...BasicDetails };
    tempData["Date"] = parseCalendarDateToLocalDate(contractTemplateData.date);
    tempData["BusinessLegalName"] = contractTemplateData.businessLegalName;
    tempData["Position"] = contractTemplateData.position;
    tempData["OfficeAddress"] = contractTemplateData.officeAddress;
    tempData["LengthOfEmployment"] = contractTemplateData.lengthOfEmployment;
    tempData["StartOfWorkDate"] = parseCalendarDateToLocalDate(
      contractTemplateData.startOfWorkDate
    );
    tempData["EndOfWorkDate"] = contractTemplateData.endOfWorkDate
      ? parseCalendarDateToLocalDate(contractTemplateData.endOfWorkDate)
      : null;
    tempData["EmployeeName"] = contractTemplateData.employeeName;
    tempData["EmployeeAddress"] = contractTemplateData.employeeAddress;
    tempData["Salary"] = contractTemplateData.salary;
    tempData["ContractDetails"] = contractTemplateData.contractDetails;
    tempData["commission"] = contractTemplateData.commission || "";
    tempData["bonus"] = contractTemplateData.bonus || "";
    if (
      contractTemplateData.contractDetails[0] &&
      contractTemplateData.contractDetails[0].templateType
    ) {
      setDesignationType(contractTemplateData.contractDetails[0].templateType);
    }
    setBasicDetails(tempData);
  }

  const goBack = () => history.goBack();

  return (
    <Page onBack={goBack} title={t("contracts.yourContract")}>
      {(isLoadingOfficeDetail || isLoadingTemplate) && <Loader />}

      <div className="container container-smd p-0">
        <Text size="14px" color="#000" weight="300">
          {officeDetail && officeDetail.name ? officeDetail.name : ""}
        </Text>
        <div>
          <div className={styles["contract-step-form"]}>
            {designationType === 1 ? (
              <PreviewPersonnelContract
                officeDetail={officeDetail}
                contractData={BasicDetails}
                contractFormDisplayData={contractFormDisplayData}
                contractDetails={contractTemplateData}
              />
            ) : (
              <PreviewAssociateContract
                officeDetail={officeDetail}
                contractData={BasicDetails}
                contractFormDisplayData={contractFormDisplayData}
                contractDetails={contractTemplateData}
              />
            )}
          </div>
        </div>
      </div>
    </Page>
  );
}

export default withTranslation()(OwnerViewContract);
